import { render, staticRenderFns } from "./taskSubmission.vue?vue&type=template&id=1e90f957&scoped=true"
import script from "./taskSubmission.vue?vue&type=script&lang=js"
export * from "./taskSubmission.vue?vue&type=script&lang=js"
import style0 from "./taskSubmission.vue?vue&type=style&index=0&id=1e90f957&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e90f957",
  null
  
)

export default component.exports